import { ConnectedAccount, StripeOnboardingResponse } from 'types/stripe';
import { api } from './instance';

const PREFIX = `/users/stripe/connect`;

export const getStripeAccount = async (stripeId: string) => {
  const { data } = await api.get(`${PREFIX}/${stripeId}`);
  return data?.item as ConnectedAccount;
};

export const stripeOnboarding = async (
  stripeId: string,
  return_url: string,
) => {
  const { data } = await api.post<StripeOnboardingResponse>(
    `${PREFIX}/${stripeId}/onboarding`,
    {
      return_url,
      refresh_url: return_url,
      type: 'account_onboarding',
    },
  );

  return data?.item;
};

export const getStripeDashboardUrl = async (stripeId: string) => {
  const { data } = await api.get<StripeOnboardingResponse>(
    `${PREFIX}/${stripeId}/dashboard`,
  );

  return data?.item?.url;
};
